<!-- 颁奖名单 -->
<style lang="less">
  .winner {
    width: 6.9rem;
    margin: 0 auto .3rem;
    position: relative;
  }

  .winner-w,
  .winner-w-pst-a {
    text-align: center;
    color: #C1272D;
  }

  .winner-w-pst-a {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 0.7rem;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 1;
  }

  .bg-buy {
    background: url("../../../assets/img/winners/winner_xian.png") top center repeat-y;
    background-size: 100% auto;
  }

  .bg-buy--top {
    background: url("../../../assets/img/winners/pre_top.png") no-repeat;
    background-size: 100% auto;
  }

  .winners-pre-list .winner-w {
    padding-top: 0.7rem;
  }
  .winner--final_3 .k-user,
  .winner--final_2 .k-user,
  .winner--final_1 .k-user {
    position: absolute;
    left: 2.1rem;
    top: 1.4rem;
    z-index: 1;
  }

  .winner-title {
    font-size: 0.38rem;
    margin-bottom: 0.2rem;
  }

  .winner-intro {
    font-size: 0.32rem;
    margin-bottom: 0.2rem;
  }

  .winner__user {
    width: 2.5rem;
    display: inline-block;
  }

  .winner-list {
    list-style: none;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .winner-list:after,
  .winner-list:before {
    clear: both;
    content: "";
    display: table;
    height: 0;
  }

  .winner-list li {
    width: 50%;
    float: left;
    margin-bottom: 0.2rem;
  }

  .stage-box {
    background-color: transparent;
    margin-bottom: 0.3rem;
  }
  .stage-box__msg {
    font-size: 30px;
    color: #C1272D;
    text-align: center;
    line-height: 48px;
    width: 80%;
    margin: 0 auto;
  }
  .user-back {
    background: #FFFFFF;
    margin: 0 0.3rem;
    margin-bottom: 0.6rem;
    padding: 0.4rem;
    font-size: 0.30rem;
  }
  .user-back h3 {
    font-size: 0.36rem;
    color: #C1272D;
    text-align: center;
  }
  .btn-group {
    /* display: box; */
    display: -ms-flexbox;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center; 
  }
  .btn-group button {
      width: 2.86rem;
      text-align: center;
  }
  .van-button--gray {
    background: #9B9B9B;
    border-radius: 0.16rem;
    color: #fff;
  }
</style>

<template>
  <div class="page page-winners" :class="{'bg-red': isEnabled}">
    <div class="page__inner">
      <k-block name="winners_1_top" />
        <div class="stage-mod stage-winners">
          <div class="stage-box stage-box--empty" style="background-color: transparent;">
            <div v-if="isEnabled" class="stage-box__msg">
              <p>恭喜以下精英用户、幸运锦鲤获得比赛奖项<br />
                获奖用户请打开<br />
                《我的战况》栏填写具体信息</p>
            </div>
            <div v-else class="stage-box__msg">
              <p><br />
                {{awardTime|time2text}} 公布<br />
                </p>
            </div>
          </div>
      </div>
      <div v-if="isEnabled" class="page__body">
        <winner-final-1 :winner="getFinalWinner(1)" />
        <winner-final-2 :winner="getFinalWinner(2)" />
        <winner-final-3 :winner="getFinalWinner(3)" />

        <winner-lucky :winner="getFinalWinner(66)" type="决赛" />
        <winner-lucky :winner="getFinalWinner(88)" type="决赛" />
        <winner-lucky :winner="getFinalWinner(666)" type="决赛" />
        <winner-lucky :winner="getFinalWinner(888)" type="决赛" />
        <!-- <winner-lucky :winner="getFinalWinner(-1)" /> -->

        <winners-pre-rank :rank="preRankBuy" intro="初赛-买入操作成功率最高奖" />
        <winners-pre-rank :rank="preRankSell" intro="初赛-卖出操作成功率最高奖" />

        <winner-lucky :winner="getPreWinner(66)" type="初赛" />
        <winner-lucky :winner="getPreWinner(88)" type="初赛" />
        <winner-lucky :winner="getPreWinner(666)" type="初赛" />
        <winner-lucky :winner="getPreWinner(888)" type="初赛" />
        <winner-lucky :winner="getPreWinner(-1)" type="初赛" block="winners_pre_last" />

        <div class="winner every">
          <k-block name="winners_every_final" />
        </div>
        <div class="winner every">
          <k-block name="winners_every_pre" />
        </div>

        <!-- <winner-every title="恭喜大家获得" intro="阳光普照奖" />
    <winner-every title="恭喜所有进入决赛者获得" intro="决赛阳光普照奖" /> -->

        <div class="user-back">
          <h3>您感觉本次活动怎么样呢？</h3>
          <br>
          <p>下次活动的举办将根据您的支持度择期举办，您什么意见？</p>
          <br>
          <div class="btn-group">
            <van-button type="danger" size="big" @click="goUrl('zhuli')">助力举办</van-button>
            <van-button type="gray" size="big" @click="goUrl('tucao')">吐槽活动</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  import {time2text} from './../../../common/utils'

  import WinnerFinal1 from './winner-final-1'
  import WinnerFinal2 from './winner-final-2'
  import WinnerFinal3 from './winner-final-3'
  import WinnerLucky from './winner-lucky'
  import WinnersPerRank from './winners-pre-rank'
  // import WinnerEvery from './winner-every'

  export default {
    components: {
      [WinnerFinal1.name]: WinnerFinal1,
      [WinnerFinal2.name]: WinnerFinal2,
      [WinnerFinal3.name]: WinnerFinal3,
      [WinnerLucky.name]: WinnerLucky,
      // [WinnerEvery.name]: WinnerEvery,
      [WinnersPerRank.name]: WinnersPerRank
    },
    computed: {
      ...mapGetters(['isAfter', 'awardTime']),
      ...mapGetters('match', ['getPreWinner', 'getFinalWinner', 'preRankSell', 'preRankBuy']),
      isEnabled() {
        const {isAfter, awardTime} = this
        return isAfter(awardTime)
      }
    },
    methods: {
      ...mapActions(['goUrl']),
      ...mapActions('match', ['loadPreRank', 'loadWinners']),
      time2text,
      async loadBuy(page) {
        return this.loadPreRank({
          type: 2,
          page,
          pageNum: 100
        })

      },
      async loadSell(page) {
        return this.loadPreRank({
          type: 3,
          page,
          pageNum: 100
        })
      }
    },
    async created() {
      await this.loadBuy(1)
      await this.loadSell(1)
      await this.loadWinners()
    }
  };

</script>
